import React from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import inductionModules, { INDUCTION_PROGRESS_KEY } from '../../data/inductionModules';
import Certificate from './Certificate';

const QUESTION_MODULE_MAP = {
  q1: 5, q2: 7, q3: 8, q4: 2, q5: 2,
  q6: 3, q7: 3, q8: 3, q9: 4,
  q10: 5, q11: 5, q12: 6, q13: 6,
  q14: 7, q15: 7, q16: 7, q17: 7,
  q18: 8, q19: 8, q20: 8
};

const formatDate = (isoString) => {
  try {
    return new Date(isoString).toLocaleDateString('en-AU', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  } catch (e) {
    return isoString;
  }
};

const modulesToReview = (incorrectQuestionIds) => {
  const moduleIds = [...new Set(incorrectQuestionIds.map((id) => QUESTION_MODULE_MAP[id]))].sort((a, b) => a - b);
  return moduleIds
    .map((id) => inductionModules.find((module) => module.id === id))
    .filter(Boolean);
};

const InductionComplete = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state || {};
  const result = state.result;

  if (!result) {
    return <Navigate to="/induction/assessment" replace />;
  }

  const { passed, score, total, passMark, incorrectQuestionIds, submittedAt, version } = result;

  const handleStartAgain = () => {
    try {
      localStorage.removeItem(INDUCTION_PROGRESS_KEY);
    } catch (e) {
      // localStorage unavailable — nothing to clear
    }
    navigate('/induction');
  };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
      {passed ? (
        <>
          <Certificate
            name={state.name}
            email={state.email}
            score={score}
            total={total}
            passMark={passMark}
            date={formatDate(submittedAt)}
            version={version}
          />

          <p>
            Your result has been emailed to the Brighton Icebergers committee, and a copy
            has been sent to you.
          </p>

          <button type="button" onClick={() => window.print()}>Print this certificate</button>

          <h2>Further reading</h2>
          <ul>
            <li><Link to="/blogs/iceberger-safety-2026">Iceberger Safety 2026 Presentation</Link></li>
            <li><Link to="/blogs/PreSwimPersonalRiskAssessment">Pre-Swim Personal Risk Assessment & Safety Checklist</Link></li>
          </ul>

          <p>
            <button type="button" onClick={handleStartAgain}>Start again</button>
          </p>
          <p className="no-print" style={{ color: '#555', fontSize: '14px' }}>
            Clears this device's module progress, so the induction starts fresh from the
            beginning &mdash; for example, if someone else is about to use this device.
          </p>
        </>
      ) : (
        <>
          <h1>Not quite — have another go</h1>
          <p role="status">
            You scored {score} out of {total}. You need {passMark} correct to pass.
          </p>

          {incorrectQuestionIds.length > 0 && (
            <>
              <p>Review these modules before you try again:</p>
              <ul>
                {modulesToReview(incorrectQuestionIds).map((module) => (
                  <li key={module.id}>
                    <Link to={`/induction/module/${module.id}`}>Module {module.id}: {module.title}</Link>
                  </li>
                ))}
              </ul>
            </>
          )}

          <p>
            <Link to="/induction/assessment" className="external-link-btn">Retake the assessment</Link>
          </p>
        </>
      )}
    </div>
  );
};

export default InductionComplete;
